export const removeIsAppUpdateScheduledFromStorage = (): void => {
  localStorage.removeItem('isAppUpdateScheduled');
};
